
export interface BackgroundOption {
  id: string;
  name: string;
  style: {
    backgroundImage: string;
  };
  textColor: string;
  buttonColor: string;
  iconColor: string;
}

export const backgroundOptions: BackgroundOption[] = [
  {
    id: 'warm-sunset',
    name: 'Warm Sunset',
    style: {
      backgroundImage: `linear-gradient(to right, rgba(251, 113, 133, 0.9), rgba(217, 70, 239, 0.9)), url('/placeholder.svg')`,
    },
    textColor: 'text-white',
    buttonColor: 'bg-white text-pink-600 hover:bg-pink-50',
    iconColor: 'text-pink-100'
  }
];
